import { render, staticRenderFns } from "./BaseInputPhone.vue?vue&type=template&id=44e5d6a2&"
import script from "./BaseInputPhone.vue?vue&type=script&lang=js&"
export * from "./BaseInputPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports